import React from 'react';
import { EventGroupFormatsEnum } from 'types/generated/client';
import CloseIcon from 'svg/CloseIcon';
import WhenAndWhere from 'screens/Tournaments/QuickCreatePage/components/WhenAndWhere';
import {
  DEFAULT_VAIR_SCORE_LIMIT,
  WhenAndWhereData,
} from 'screens/Tournaments/QuickCreatePage/types';
import { ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';
import { Props } from './types';

interface ModalEditVairEventProps {
  isOpen: boolean;
  onClose: () => void;
  event: Props['event'];
  onUpdate: (data: WhenAndWhereData) => Promise<void>;
}

export default function ModalEditVairEvent({
  isOpen,
  onClose,
  event,
  onUpdate,
}: ModalEditVairEventProps) {
  return (
    <Modal isOpen={isOpen} handleClose={onClose}>
      <div className="relative pt-6">
        <ButtonText onClick={onClose} className="absolute right-4 top-4">
          <CloseIcon className="h-6 w-6" />
        </ButtonText>

        <WhenAndWhere
          mode="edit"
          eventId={event.id}
          className="w-full"
          initialData={{
            title: event.title,
            selectDate: event.startDateTime ? new Date(event.startDateTime) : new Date(),
            selectStartTime: event.startDateTime
              ? new Date(event.startDateTime).getHours() * 60 +
                new Date(event.startDateTime).getMinutes()
              : 480,
            venue: {
              id: event.venue?.id || '',
              address: event.venue?.addressString || event.addressString || '',
              latitude: event.venue?.geometry?.coordinates?.[1] || event.latitude || 0,
              longitude: event.venue?.geometry?.coordinates?.[0] || event.longitude || 0,
              venueImageURL: event.venue?.images?.[0]?.url || '',
              city: event.city || null,
            },
            isVairEvent: true,
            // Not rendered for VAIR events (toggle is Traditional-RR only) and the
            // update mutation doesn't persist it — hydration only.
            isVairRequired: false,
            scoreLimit:
              event.groups?.find((g) => g.format === EventGroupFormatsEnum.VairRoundRobin)
                ?.totalPoints || DEFAULT_VAIR_SCORE_LIMIT,
            minCourts: 0,
          }}
          onUpdate={onUpdate}
          prevStep={onClose}
        />
      </div>
    </Modal>
  );
}
